import { Trans, useLingui } from '@lingui/react/macro'
import { customerHooks } from '$src/lib/trpcHooks'
import { Card, Center, Group, Loader, Stack, Text } from '@mantine/core'
import { AppPage } from '@markku/components'
import { isCompanyType } from '@markku/utils'
import { IconBuilding, IconChevronRight } from '@tabler/icons-react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { UserEmailBadge } from '$src/components/company-portal/UserEmailBadge'

function CompanyPortalIndex() {
  const { t } = useLingui()
  const navigate = useNavigate()
  const { data: customersData, isLoading } = customerHooks.useList()

  const companyCustomers = (customersData?.data || []).filter((c) =>
    isCompanyType(c.type),
  )

  useEffect(() => {
    if (!isLoading && companyCustomers.length === 1) {
      navigate({
        to: `/company-portal/${companyCustomers[0].id}`,
        replace: true,
      })
    }
  }, [isLoading, companyCustomers, navigate])

  if (isLoading || companyCustomers.length === 1) {
    return (
      <AppPage
        title={t`Company portal`}
        showBackButton={false}
        rightSection={<UserEmailBadge />}
      >
        <Center py="xl">
          <Loader size="md" />
        </Center>
      </AppPage>
    )
  }

  if (companyCustomers.length === 0) {
    return (
      <AppPage
        title={t`Company portal`}
        showBackButton={false}
        rightSection={<UserEmailBadge />}
      >
        <Center py="xl">
          <Text c="dimmed">
            <Trans>No company accounts found</Trans>
          </Text>
        </Center>
      </AppPage>
    )
  }

  return (
    <AppPage
      title={t`Company portal`}
      showBackButton={false}
      rightSection={<UserEmailBadge />}
    >
      <Stack gap="md">
        {companyCustomers.map((company) => (
          <Card
            key={company.id}
            withBorder
            radius="md"
            p="md"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate({ to: `/company-portal/${company.id}` })}
          >
            <Group justify="space-between" align="center">
              <Group gap="md">
                <IconBuilding size={24} />
                <Stack gap={2}>
                  <Text fw={600}>{company.name}</Text>
                  <Text size="sm" c="dimmed">
                    <Trans>{company.properties?.length || 0} properties</Trans>
                  </Text>
                </Stack>
              </Group>
              <IconChevronRight size={20} color="var(--mantine-color-gray-5)" />
            </Group>
          </Card>
        ))}
      </Stack>
    </AppPage>
  )
}

export const Route = createFileRoute('/_app/company-portal/')({
  component: CompanyPortalIndex,
})
